interface ObjectProps {
    [key: string]: any;
}


export default {
    namespace: 'provider',
    state: {
        user: {},
    },
    reducers: {
        update(state: any, { payload }: ObjectProps) {
            return { ...state, ...payload };
        },
    },
    effects: {},
    subscriptions: {},
};
